import React from 'react';
export function Header() {
  return <header className="absolute top-0 left-0 w-full z-[80] px-6 py-6 flex justify-between items-start" data-id="element-197">
      {/* Logo + institutional descriptor */}
      <div className="flex flex-col gap-1" data-id="element-198">
        <h1 className="text-white font-heading font-bold text-lg sm:text-xl tracking-wider uppercase leading-tight" data-id="element-199">
          Buceo y<br data-id="element-200" />
          Navegación
        </h1>
        <div className="text-brand-primary text-[10px] sm:text-xs font-mono uppercase tracking-widest mt-2 flex flex-col gap-0.5" data-id="element-201">
          <span data-id="element-202">Escuela de buceo</span>
          <span data-id="element-203">Viajes grupales</span>
          <span data-id="element-204">Agencia de turismo hc 26.614</span>
        </div>
      </div>
    </header>;
}